module.exports = __webpack_public_path__ + "img/emoji-message-bubble-240x240.8ba7a42d.png";